exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexible[_v-602abb3a]{display:-ms-flexbox;display:flex}.col-sm-6 .btn-link[_v-602abb3a]{padding-top:15px;white-space:normal;color:#000;padding-bottom:0}@media(max-width:768px){.col-sm-6 .btn-link[_v-602abb3a]{padding:0 15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-602abb3a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Product/Product-detail-rate.vue
// module id = 437
// module chunks = 0